import gql from 'graphql-tag';

export const REMOVE_BUBBLE_TEXT = gql`
  mutation removeBubbleText($id: Int!) {
    bubbleText {
      remove(bubbleTextId: $id)
    }
  }
`;
